var map = {
	"./add.svg": [
		1269,
		77
	],
	"./addBlack.svg": [
		1270,
		78
	],
	"./addWhite.svg": [
		1271,
		79
	],
	"./add_assignee.svg": [
		1272,
		80
	],
	"./add_to_dashboard.svg": [
		1273,
		81
	],
	"./add_workorder.svg": [
		1274,
		82
	],
	"./additional.svg": [
		1275,
		83
	],
	"./asset.svg": [
		1276,
		84
	],
	"./assistant-blue.svg": [
		1277,
		85
	],
	"./assistant-grey.svg": [
		1278,
		86
	],
	"./attach.svg": [
		1279,
		87
	],
	"./bill.svg": [
		1280,
		88
	],
	"./billHistory.svg": [
		1281,
		89
	],
	"./billHistorySelected.svg": [
		1282,
		90
	],
	"./billSelected.svg": [
		1283,
		91
	],
	"./billing.svg": [
		1284,
		92
	],
	"./billingSelected.svg": [
		1285,
		93
	],
	"./bot.svg": [
		1286,
		94
	],
	"./bouncedOrders.svg": [
		1287,
		95
	],
	"./bouncedOrdersSelected.svg": [
		1288,
		96
	],
	"./cameraBlue.svg": [
		1289,
		97
	],
	"./cameraRed.svg": [
		1290,
		98
	],
	"./cancel.svg": [
		1291,
		99
	],
	"./cancelOrder.svg": [
		1292,
		100
	],
	"./chat.svg": [
		1293,
		101
	],
	"./chatBlue.svg": [
		1294,
		102
	],
	"./chatRed.svg": [
		1295,
		103
	],
	"./checklist.svg": [
		1296,
		104
	],
	"./client-comments.svg": [
		1297,
		105
	],
	"./client-delete.svg": [
		1298,
		106
	],
	"./confirmOrder.svg": [
		1299,
		107
	],
	"./content.svg": [
		1300,
		108
	],
	"./createOrder.svg": [
		1301,
		109
	],
	"./createOrderSelected.svg": [
		1302,
		110
	],
	"./customer.svg": [
		1303,
		111
	],
	"./dashboard.svg": [
		1304,
		112
	],
	"./delete.svg": [
		1305,
		113
	],
	"./delivered.svg": [
		1306,
		114
	],
	"./diesel.svg": [
		1307,
		115
	],
	"./document.svg": [
		1308,
		116
	],
	"./duePayments.svg": [
		1309,
		117
	],
	"./duePaymentsSelected.svg": [
		1310,
		118
	],
	"./edit-pencil.svg": [
		1311,
		119
	],
	"./edit.svg": [
		1312,
		120
	],
	"./energy.svg": [
		1313,
		121
	],
	"./enter.svg": [
		1314,
		122
	],
	"./expand.svg": [
		1315,
		123
	],
	"./expired.svg": [
		1316,
		124
	],
	"./expiredSelected.svg": [
		1317,
		125
	],
	"./filter.svg": [
		1318,
		126
	],
	"./gallery.svg": [
		1319,
		127
	],
	"./generateInvoice.svg": [
		1320,
		128
	],
	"./graphs.svg": [
		1321,
		129
	],
	"./graphsSelected.svg": [
		1322,
		130
	],
	"./grey-right-arrow.svg": [
		1323,
		131
	],
	"./headcount.svg": [
		1324,
		132
	],
	"./hierarchy.svg": [
		1325,
		133
	],
	"./hierarchySelected.svg": [
		1326,
		134
	],
	"./hourglass-outline.svg": [
		1327,
		135
	],
	"./import.svg": [
		1328,
		136
	],
	"./in progress.svg": [
		1329,
		137
	],
	"./instructions.svg": [
		1330,
		138
	],
	"./inventory.svg": [
		1331,
		139
	],
	"./inventoryCheck.svg": [
		1332,
		140
	],
	"./inventoryCheckSelected.svg": [
		1333,
		141
	],
	"./invoice.svg": [
		1334,
		142
	],
	"./leftArr-blue.svg": [
		1335,
		143
	],
	"./leftArr-grey.svg": [
		1336,
		144
	],
	"./location.svg": [
		1337,
		145
	],
	"./locations.svg": [
		1338,
		146
	],
	"./mappingPeople.svg": [
		1339,
		147
	],
	"./mappingPeopleSelected.svg": [
		1340,
		148
	],
	"./message.svg": [
		1341,
		149
	],
	"./meter.svg": [
		1342,
		150
	],
	"./meters.svg": [
		1343,
		151
	],
	"./new-message.svg": [
		1344,
		152
	],
	"./noResultsSelected.svg": [
		1345,
		153
	],
	"./orderTracking.svg": [
		1346,
		154
	],
	"./orderTrackingSelected.svg": [
		1347,
		155
	],
	"./pendingOrders.svg": [
		1348,
		156
	],
	"./pendingOrdersSelected.svg": [
		1349,
		157
	],
	"./people.svg": [
		1350,
		158
	],
	"./pharmacyCatalog.svg": [
		1351,
		159
	],
	"./pharmacyCatalogSelected.svg": [
		1352,
		160
	],
	"./ppm.svg": [
		1353,
		161
	],
	"./purchase.svg": [
		1354,
		162
	],
	"./purchaseSelected.svg": [
		1355,
		163
	],
	"./purchase_order.svg": [
		1356,
		164
	],
	"./qr.svg": [
		1357,
		165
	],
	"./qrCode.svg": [
		1358,
		166
	],
	"./refresh.svg": [
		1359,
		167
	],
	"./reminder-bell.svg": [
		1360,
		168
	],
	"./remove.svg": [
		1361,
		169
	],
	"./report.svg": [
		1362,
		170
	],
	"./return.svg": [
		1363,
		171
	],
	"./returnSelected.svg": [
		1364,
		172
	],
	"./returns.svg": [
		1365,
		173
	],
	"./returnsSelected.svg": [
		1366,
		174
	],
	"./right-arrow.svg": [
		1367,
		175
	],
	"./rightArr-blue.svg": [
		1368,
		176
	],
	"./rightArr-grey.svg": [
		1369,
		177
	],
	"./rules.svg": [
		1370,
		178
	],
	"./rulesSelected.svg": [
		1371,
		179
	],
	"./search.svg": [
		1372,
		180
	],
	"./selectedBot.svg": [
		1373,
		181
	],
	"./selectedChat.svg": [
		1374,
		182
	],
	"./selectedContent.svg": [
		1375,
		183
	],
	"./selectedDashboard.svg": [
		1376,
		184
	],
	"./selectedFilter.svg": [
		1377,
		185
	],
	"./send_message.svg": [
		1378,
		186
	],
	"./set_date.svg": [
		1379,
		187
	],
	"./settings.svg": [
		1380,
		188
	],
	"./settingsSelected.svg": [
		1381,
		189
	],
	"./shrink.svg": [
		1382,
		190
	],
	"./star.svg": [
		1383,
		191
	],
	"./taxes.svg": [
		1384,
		192
	],
	"./taxesSelected.svg": [
		1385,
		193
	],
	"./tick.svg": [
		1386,
		194
	],
	"./tick_grey.svg": [
		1387,
		195
	],
	"./tickmark red.svg": [
		1388,
		196
	],
	"./tickmark white.svg": [
		1389,
		197
	],
	"./timer.svg": [
		1390,
		198
	],
	"./user.svg": [
		1391,
		199
	],
	"./vendor.svg": [
		1392,
		200
	],
	"./workorder.svg": [
		1393,
		201
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 830;
module.exports = webpackAsyncContext;